import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card';
import { Input } from '@/components/ui/input';
import { Field } from '@/components/triggers/Field';
import type { VideoLookInput } from '@/types/content';

export function VideoLookCard({
  look,
  onChange,
}: {
  look: VideoLookInput;
  onChange: (next: VideoLookInput) => void;
}) {
  return (
    <Card>
      <CardHeader>
        <CardTitle>Outfit &amp; setting (optional)</CardTitle>
        <CardDescription>
          Same face, new look for this video. Leave blank to keep the persona's usual outfit and
          background. Applies to every frame, so it never flickers back.
        </CardDescription>
      </CardHeader>
      <CardContent className="grid grid-cols-1 gap-4 md:grid-cols-2">
        <Field label="Outfit">
          <Input
            value={look.outfit}
            onChange={(e) => onChange({ ...look, outfit: e.target.value })}
            placeholder="e.g. a light-blue button-down, sleeves rolled"
          />
        </Field>
        <Field label="Setting">
          <Input
            value={look.setting}
            onChange={(e) => onChange({ ...look, setting: e.target.value })}
            placeholder="e.g. a bright office with a wooden desk, afternoon light"
          />
        </Field>
      </CardContent>
    </Card>
  );
}
